import * as utils from "../../../../utils";
// let host = '/cm-sites-media-matrix-service/';
import { request } from '@cm-sites-webber/components';


let host = '/cm-sites-media-consumer/contentManager/';
const Apis = {
    getList: host + 'indexList',  //榜单列表
    getDeptAll: '/cm-sites-sys/dept/getAll',//获取媒体部门
    listExport: host + 'indexListExport',//导出execl
    listPdf: host + 'indexListPdf',//导出pdf
    getData:'/cm-sites-media-consumer/position/overview/getPositionTypeGrade'

}
//获取媒体列表
export function getList(body, callBack) {
    let url = Apis.getList + utils.params(body);
    request( {
        url,
        method: 'get',
        contentType: "json",
        callBack: (response)=>callBack(response)
    })
}
export  function getData(body,callBack) {
    let url = Apis.getData + utils.params(body);
    request( {
        url,
        method: 'get',
        contentType: "json",
        callBack: (response)=>callBack(response)
    })
}

//获取所有部门
export function getDeptAll(callBack) {
    let url = Apis.getDeptAll;
    request( {
        url,
        method: 'get',
        contentType: "json",
        callBack: (response)=>callBack(response)
    })
}
//导出execl
export function listExport(body, callBack) {
    let url = Apis.listExport;
    // callBack(url)
    request( {
        url,
        body,
        method: 'downloadGet',
    })
}
// 导出pdf
export function listPdf(body, callBack) {
    let url = Apis.listPdf;
    request( {
        url,
        body,
        method: 'downloadGet',
    })
}